import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { SvgIcon } from '../../components/Icon';
import { IHeaderMenuItem } from './types';
import { theme } from '../../styles/theme';
import { optionHover } from '../../styles/shareableStyles';

interface IProps extends LinkProps, IHeaderMenuItem {
  onClick?: () => void;
  disabled?: boolean;
}

const MenuItem = styled(Link)<{ $isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  column-gap: 12px;
  width: 100%;
  padding: 12px 16px;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  transition: color 0.2s ease-in-out;
  color: ${theme.colors.secondary900};
  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  &:hover {
    cursor: pointer;
    ${optionHover};
  }
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.3;
    `};
`;

const MenuItemContainer = styled.div`
  flex: 1;
  font-size: 12px;
  line-height: normal;
`;
const Label = styled.div`
  font-weight: 600;
`;
const Description = styled.div`
  font-weight: 400;
`;

const HeaderMenuItem = ({
  label,
  to,
  icon,
  description,
  onClick,
  disabled,
  ...linkProps
}: IProps) => (
  <MenuItem to={to} onClick={onClick} $isDisabled={disabled} {...linkProps}>
    <SvgIcon
      name={icon}
      width={24}
      height={24}
      customFill={theme.colors.mainBlue}
    />
    <MenuItemContainer>
      <Label>{label}</Label>
      <Description>{description}</Description>
    </MenuItemContainer>
  </MenuItem>
);

export default HeaderMenuItem;
